import React, {Component} from 'react';
import objeler from '../objeler';
import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogStyles from './DialogStyles'
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Draggable from 'react-draggable';
import Paper from '@material-ui/core/Paper';

function PaperComponent(props) {
    return (
        <Draggable
            handle={props.children[0].props.id != undefined ? "#" + props.children[0].props.id : "#draggable-dialog-title"}
            cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props}
                   style={{overflow: 'inherit'}}
            />
        </Draggable>
    );
}

class ModalBase extends Component<props> {
    constructor(props) {
        super(props);
    }

    closeModal = (e, b) => {
        if (b === "OK") {
            this.props.closeModal(objeler.tarik);
        } else
            this.props.closeModal("Cancel");
    }

    render() {
        const {classes, dialogId} = this.props;
        return (
            <div
            >
                <Dialog
                    onClose={(event, reason) => {
                        if (reason !== 'backdropClick') {
                            this.closeModal(event)
                        }
                    }}
                    PaperComponent={PaperComponent}
                    aria-labelledby={dialogId != undefined ? dialogId : "draggable-dialog-title"}
                    open={this.props.isOpen}
                    className={classes.form}
                    maxWidth='lg'
                    transitionDuration={50}
                >
                    <DialogTitle id={dialogId != undefined ? dialogId : "draggable-dialog-title"}
                                 onClose={e => this.closeModal(e)} style={{cursor: 'move'}}>
                        {this.props.title}
                        <IconButton aria-label="close" className={classes.dButton} onClick={e => this.closeModal(e)}>
                            <CloseIcon/>
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers
                                   style={{overflow: 'hidden'}}
                    >
                        {this.props.children}
                    </DialogContent>
                    <DialogActions>
                        <Button autoFocus onClick={this.closeModal}
                                disableRipple={true}
                                disableTouchRipple={true}
                                focusRipple={false}
                                className={classes.closeButton}
                        >
                            Cancel
                        </Button>
                        <Button autoFocus onClick={e => this.closeModal(e, "OK")}
                                className={classes.closeButton}
                                disableRipple={true}
                                disableTouchRipple={true}
                                focusRipple={false}
                        >
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default withStyles(DialogStyles)(ModalBase)